import signatureTypes from 'constants/signatureTypes';
import { translate } from 'hooks/useTranslate';
import { EnvelopeStatus } from 'modules/envelopes/components/EnvelopesTable/envelopeStatus';
import { SelectorOption } from 'types';

export const statusOptions: SelectorOption[] = [
  { value: 'PENDING', label: translate('Pending') },
  { value: 'COMPLETED', label: translate('Completed') },
  { value: 'DECLINED', label: translate('Declined') },
];

export const signatureTypeOptions: SelectorOption[] = [
  { value: 'INVITATION_LETTERS', label: translate('InvitationLetters') },
  { value: 'COUNCILS', label: translate('Councils') },
  { value: 'FREE_SIGNATURES', label: translate('FreeSignatures') },
  { value: 'BOARDS', label: translate('Boards') },
  { value: 'TENDER_OFFERS', label: translate('TenderOffers') },
];

export const statusFilters = {
  ALL: [
    EnvelopeStatus.CREATED,
    EnvelopeStatus.SENT,
    EnvelopeStatus.DELIVERED,
    EnvelopeStatus.SIGNED,
    EnvelopeStatus.COMPLETED,
    EnvelopeStatus.DECLINED,
    EnvelopeStatus.VOIDED,
    EnvelopeStatus.EXPIRED,
    EnvelopeStatus.CORRECT,
    EnvelopeStatus.TEMPLATE,
    EnvelopeStatus.DELETED,
    EnvelopeStatus.AUTHORITATIVE_COPY,
    EnvelopeStatus.TRANSFER_COMPLETED,
    EnvelopeStatus.TIMEOUT,
  ],
  PENDING: [EnvelopeStatus.SENT, EnvelopeStatus.DELIVERED],
  COMPLETED: [EnvelopeStatus.COMPLETED],
  DECLINED: [
    EnvelopeStatus.DECLINED,
    EnvelopeStatus.VOIDED,
    EnvelopeStatus.EXPIRED,
    EnvelopeStatus.DELETED,
  ],
};

export const signatureTypeFilters = {
  INVITATION_LETTERS: [signatureTypes.INVITATION_LETTER],
  TENDER_OFFERS: [
    signatureTypes.TENDER_OFFER,
    signatureTypes.TENDER_OFFER_PARTNER,
    signatureTypes.TENDER_OFFER_BENEF,
    signatureTypes.TENDER_OFFER_SHARES,
  ],
  FREE_SIGNATURES: [
    signatureTypes.FREE_SIGNATURE,
    signatureTypes.FREE_SIGNATURE_BENEF,
    signatureTypes.FREE_SIGNATURE_PARTNER,
    signatureTypes.FREE_SIGNATURE_INVESTOR,
    signatureTypes.FREE_SIGNATURE_DIRECTOR,
    signatureTypes.FREE_SIGNATURE_BENEF_ALL,
    signatureTypes.FREE_SIGNATURE_PARTNER_ALL,
    signatureTypes.FREE_SIGNATURE_INVESTOR_ALL,
    signatureTypes.FREE_SIGNATURE_DIRECTOR_ALL,
  ],
  BOARDS: [
    signatureTypes.BOARD_ACT,
    signatureTypes.BOARD_ASSISTANTS,
    signatureTypes.BOARD_CERTIFICATE,
  ],
  COUNCILS: [signatureTypes.COUNCIL_ACT, signatureTypes.COUNCIL_CERTIFICATE],
};
